import React from 'react';
import { FormText, DescriptionList } from '@doda/io-react/common';
import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import styles from './index.module.scss';
import { CurrentConditionModalBodyConditions } from '../CurrentConditionModalBodyConditions';

/**
 * 現在の検索条件モーダルボディ
 */
interface Props {
  /** 検索条件名 */
  conditionName: string;
  /** 入力変更のコールバック関数 */
  onChangeInput: (value: string) => void;
  /** 現在の検索条件データ */
  currentConditionData: SearchConditionLabelResponse;
}

/**
 * 現在の検索条件モーダルボディを表示するコンポーネント
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} 現在の検索条件モーダルボディを表示する要素
 */
export const CurrentConditionModalBody: React.FC<Props> = ({
  conditionName,
  onChangeInput,
  currentConditionData,
}) => {
  return (
    <>
      <div className={styles.currentConditionModal__body}>
        <DescriptionList
          listData={[
            {
              contents: (
                <FormText
                  className={styles.currentConditionModal__inputWrapper}
                  defaultValue={conditionName}
                  onChange={(value) => onChangeInput(value)}
                />
              ),
              title: '検索条件名',
            },
          ]}
          type="column2"
        />
      </div>
      <CurrentConditionModalBodyConditions
        currentConditionData={currentConditionData}
      />
    </>
  );
};
